<script setup lang="ts">
import { OrganizationSelector, StackLayout } from '@rfc/rfc-components-library'
import type { AdminDeviceFiltersType } from '@rfc/rfc-components-library/types'
import type { UseTableModelType } from '../../types/hooks/UseTableModelTypes'
import type { DeviceModel } from '../../types/models/DeviceModel'

type Props = UseTableModelType<DeviceModel, AdminDeviceFiltersType>
defineProps<Props>()
</script>

<template>
    <StackLayout :gap="8" class="w-full" isResponsiveSmallScreen>
        <OrganizationSelector
            :organizationId="
                filters?.value?.organization_id
                    ? parseInt(filters?.value?.organization_id?.toString() ?? '')
                    : undefined
            "
            @select="handleChangeFilters({ organization_id: $event?.id })" />
    </StackLayout>
</template>
